import { render, staticRenderFns } from "./wfselect.vue?vue&type=template&id=6de1ae81&"
import script from "./wfselect.vue?vue&type=script&lang=js&"
export * from "./wfselect.vue?vue&type=script&lang=js&"
import style0 from "./wfselect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports